import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import {
    getBudgetProposalFromInscription,
    InscriptionT,
} from 'routes/BudgetModule/shared/entities/inscription';
import { isActiveBudgetProposal } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { PHASE_ID } from 'routes/BudgetModule/config/constants';

/** Check if an inscription belongs to an active budget proposal */
export const isInscriptionBelongsToActiveBudgetProposal = (
    inscription: InscriptionT,
    budgetProposals: BudgetProposalT[],
): boolean => {
    const budgetProposal = getBudgetProposalFromInscription(
        inscription,
        budgetProposals,
    );
    return isActiveBudgetProposal(budgetProposal);
};

/** If the phase of a budget has been manually changed, its inscriptions
 * might not have been to the right format. For this reason, we make sure to
 * display inscription that have been moved to the current phase.
 */
export const hasInscriptionBeenSetToRightPhase = (
    inscription: InscriptionT,
): boolean => {
    const inscriptionCurrentId = inscription[PHASE_ID];
    return !!inscriptionCurrentId;
};
